module.exports = __webpack_public_path__ + "assets/images/project/meta-desktop.jpg?v=af5dc1d5";